export default "/static/build/season-winner-3.png";